// src/utils/dateUtils.js
export function addDays(date, n) {
  const d = new Date(date);
  d.setDate(d.getDate() + n);
  return d;
}

export function getMonday(d) {
  const dd = new Date(d);
  const day = dd.getDay();
  const diff = dd.getDate() - day + (day === 0 ? -6 : 1);
  dd.setDate(diff);
  dd.setHours(0, 0, 0, 0);
  return dd;
}

export function formatDate(dateLike) {
  const d = new Date(dateLike);
  return d.toLocaleDateString("ro-RO", { day: "2-digit", month: "2-digit" });
}


export function formatDateLocal(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}